import { reportSuggestionsResponseMock } from "./consts";
import { ReportSuggestionsResponse } from "./types";

export const fetchReportSuggestions = async (
  responseId: number,
  functionKey: string
): Promise<ReportSuggestionsResponse> => {
  if (process.env.REACT_APP_USE_MOCKED_API === "true") {
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return reportSuggestionsResponseMock;
  }

  const apiRequest = `${process.env.REACT_APP_SUGGEST_REPORT_URL}${functionKey}`;
  const requestBody = { response_id: responseId };

  const response = await fetch(apiRequest, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const data: ReportSuggestionsResponse = await response.json();
  return data;
};
